<template>
  <el-row
type="flex"
justify="space-between"
align="middle">
    <div style="display: flex; align-items: center;">
      <el-button
        icon="el-icon-back"
        @click="() => handleList()"
      >
        Danh sách
      </el-button>
      <h1 class="card-container__title ml-m">
        {{ title }} <span class="card-container__subtitle">({{ total }})</span>
      </h1>
    </div>
    <el-row
      class="card-container__actions"
      type="flex"
      justify="end"
      align="middle"
    >
      <el-button
        v-if="permission.UPDATE && selectedPermission.UPDATE"
        type="primary"
        size="medium"
        icon="el-icon-plus"
        :disabled="disabled"
        :plain="plain"
        @click="$emit('create')"
        >Thêm mới</el-button
      >
      <el-button
        class="ml-s"
        type="primary"
        size="medium"
        icon="el-icon-refresh"
        :plain="plain"
        :disabled="disabled"
        @click="$emit('refresh')"
        >Làm mới</el-button
      >
      <el-button
        class="ml-s"
        type="primary"
        size="medium"
        icon="el-icon-edit"
        :plain="true"
        :disabled="disabled"
        @click="handleShow(item)"
        >Hồ sơ</el-button
      >
    </el-row>
  </el-row>
</template>

<script>
export default {
  name: "CardHeader",
  props: {
    item: Object,
    config: Object,
    total: Number,
    disabled: Boolean,
    plain: Boolean,
    size: String,
    permission: Object,
    selectedPermission: Object
  },
  computed: {
    title() {
      return (
        "Danh sách liên kết " +
        this.config.extra.name +
        `: ${this.item?.extra?.name}`
      );
    },
  },
  methods: {
    handleList() {
      this.$router.push({
        name: `${this.config.extra.key}`,
      })
    },
    handleShow(item) {
      this.$router.push({
        name: `${this.config.extra.key}_show`,
        params: { id: item.id },
      })
    },
  }
};
</script>

<style lang="scss" scoped></style>
